<template>
  <b-modal
    v-model="isShow"
    @hidden="
      () => {
        $emit('update:isShow', false);
      }
    "
    @shown="openForm"
    dialog-class="dialog-class"
    centered
  >
    <template #modal-header="{ close }">
      <h4 class="mb-0 text-primary">
        {{ $t(data ? "ar_client_edit_travel_agent" : "ar_client_add_travel_agent") }}
      </h4>
      <!--  <h4 class="mb-0 text-primary" v-else>
          {{ $t("ar_client_update_debit_account") }}
        </h4> -->
      <ez-icon
        icon="ezAr-icon-x"
        size="24"
        class="cursor-pointer"
        color="#114A9F"
        @click="close()"
      />
    </template>

    <FormItems ref="formRef" :items="formItems" :formData.sync="formData" />

    <template #modal-footer="">
      <LoadingModalButton
        ref="buttonRef"
        :disabled="isLoading"
        @click="createUpdateTravelAgent"
        variant="primary"
      >
        {{ $t("ar_common_save") }}
      </LoadingModalButton>
    </template>
  </b-modal>
</template>
<style lang="scss" scoped>
::v-deep .dialog-class {
  max-width: 700px !important;
}
</style>
<script>
import { computed, ref, defineComponent, getCurrentInstance } from "@vue/composition-api";
import axios from "axios";
import {
  CommonActiveStatus,
  TravelAgentType,
  TravelAgentIsOverDraftStatus,
} from "../../ultils/status";
import FormItems from "../../ultils/Form/FormItems.vue";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";

import { arClient } from "@/api/ar-client";
import _ from "lodash";
import LoadingModalButton from "../../ultils/Button/LoadingModalButton.vue";
export default defineComponent({
  name: "ModalCLient",
  components: {
    FormItems,
    LoadingModalButton,
  },
  props: {
    data: Object,
    isShow: Boolean,
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;
    const formRef = ref();
    const formRef2 = ref();
    const buttonRef = ref();
    const formData = ref({
      InActive: 1,
      Gender: "MALE",
      IsOverDraft: "false",
      TravelAgentType: 1,
    });

    const formItems = computed(() => [
      {
        type: "divider",
        variant: "text",
        label: "Thông tin đại lý",
        wrapperClass: "col-12",
      },
      {
        type: "cleave",
        cleaveType: "uppercase",
        disabled: props.data,
        name: "TravelAgentCode",
        rules: { code: true, min: 2 },
        wrapperClass: "col-4",
        required: true,
        label: "ar_client_company_code",
      },

      {
        type: "string",
        disabled: props.data,
        name: "NameVi",

        required: true,
        label: "ar_client_company_name",
        wrapperClass: "col-4",
      },
      {
        type: "select",
        noClearable: true,
        dataSource: Object.keys(TravelAgentType).map((key) => ({
          Id: TravelAgentType[key],
          Label: key,
        })),

        name: "TravelAgentType",
        labelOption: "Label",
        label: "ar_client_travel_agent_type",
        wrapperClass: "col-4",
      },
      {
        type: "string",
        disabled: props.data,
        name: "ZipCode",

        label: "ar_common_zipcode",
        wrapperClass: "col-4",
      },
    

      {
        type: "cleave",
        cleaveType: "uppercase",
        name: "TaxCode",

        rules: { max: 20, min: 2, tax: true },
        wrapperClass: "col-4",
        label: "ar_common_tax_code",
      },
      {
        type: "string",
        disabled: props.data,
        name: "Tel1",
        rules: { phone: true },
        label: "ar_common_phone",
        wrapperClass: "col-4",
      },
     /*  {
        type: "string",
        disabled: props.data,
        name: "Tel2",
        rules: { phone: true },
        label: "ar_common_phone2",
        wrapperClass: "col-4",
      }, */
      {
        type: "string",

        name: "Address",
        wrapperClass: "col-4",
        label: "ar_common_address",
      },
      {
        type: "string",
        disabled: props.data,
        name: "StateVi",
        wrapperClass: "col-4",
        label: "ar_client_district",
      },

      {
        type: "string",

        name: "CityVi",
        wrapperClass: "col-4",
        label: "ar_common_city",
      },
      {
        type: "string",
        wrapperClass: "col-4",
        name: "CountryVi",

        label: "ar_common_country",
      },
      {
        type: "select",
        dataSource: TravelAgentIsOverDraftStatus.map((stt) => ({
          Label: vm.$t(stt.title),
          Id: stt.value ? "true" : "false",
        })),
        noClearable: true,
   
        name: "IsOverDraft",
        labelOption: "Label",
        label: "ar_client_over_draft_status",
        wrapperClass: "col-4",
      },
      {
        type: "select",
        dataSource: CommonActiveStatus.map((stt) => ({
          Label: vm.$t(stt.title),
          Id: stt.value,
        })),
        noClearable: true,
        name: "InActive",
        
        labelOption: "Label",
        label: "ar_client_status",
        wrapperClass: "col-4",
      },
      {
        type: "string",
        variant: "textarea",
        rows:3,
        name: "DescriptionVi",
        label: "ar_client_note",
        wrapperClass: "col-12",
      },
      {
        type: "divider",
        variant: "text",
        label: "Thông tin người dùng",
        wrapperClass: "col-12",
      },
      {
        type: "cleave",
        cleaveType: "uppercase",
        disabled: props.data,
        name: "UserCode",
        rules: { code: true, min: 2 },
        wrapperClass: "col-6",
        required: true,
        label: "ar_client_user_code",
      },

      {
        type: "string",
        disabled: props.data,
        wrapperClass: "col-6",
        name: "Email",
        rules: { email: true },
        required: true,
        label: "golf_common_email",
      },
      {
        type: "string",
        wrapperClass: "col-6",
        name: "Fullname",

        required: true,
        label: "ar_client_first_and_last_name",
      },
      {
        type: "string",
        wrapperClass: "col-6",
        name: "Phone",
        rules: { phone: true },
        required: true,
        label: "ar_common_phone",
        placeholder: "ar_common_phone",
      },
    ]);
    const formItems2 = computed(() => []);

    const { fetchData: mutationTravelAgent, isLoading } = useFetch(
      !props.data ? arClient.api_AR_ICL01 : arClient.api_AR_UCL01,
      {
        showLoading: true,
        afterErrorOrTimeoutFunction: {
          func: () => buttonRef?.value?.stopLoading(),
        },
        nextFunction: (data) => {
          emit("refetch");

          emit("update:isShow", false);
        },
      }
    );

    const createUpdateTravelAgent = () => {
      formRef.value.validate().then((success) => {
        if (success) {
          buttonRef?.value?.startLoading();
          const temp = {
            TravelAgent: {
              CityVi: formData.value.CityVi,
              TravelAgentCode: formData.value.TravelAgentCode,
              NameVi: formData.value.NameVi,
              DescriptionVi: formData.value.DescriptionVi,
              TravelAgentType: formData.value.TravelAgentType,
              Tel1: formData.value.Tel1,
              Tel2: formData.value.Tel2,
              InActive: formData.value.InActive,
              IsOverDraft: formData.value.IsOverDraft === "true" ? true : false,
              ZipCode: formData.value.ZipCode,
              StateVi: formData.value.StateVi,
              Address1: formData.value.Address1,
              Address2: formData.value.Address2,

              TaxCode: formData.value.TaxCode,
            },
            Tauser: {
              UserCode: formData.value.UserCode,
              Email: formData.value.Email,
              Fullname: formData.value.Fullname,
              Phone: formData.value.Phone,
            },
          };
          mutationTravelAgent(temp);
        }
      });
    };
    const openForm = () => {
      if (props.data) {
        const temp = { ...formData.value };
        _.forEach(props.data, (v, key) => {
          if (formItems.value.map((item) => item.name).includes(key)) {
            temp[key] = v;
          }
        });

        formData.value = {
          ...temp,
          Id: props.data.Id,
          TauserForGroup: props.data.TauserForGroup.map((v) => v.TaUserGroupId),
          UserCode: props.data.TaUserCode,
        };
      }
    };

    return {
      formRef2,
      formItems2,
      isLoading,
      formData,
      formItems,
      createUpdateTravelAgent,
      formRef,
      openForm,
      buttonRef,
    };
  },
  methods: {
    test() {},
  },
});
</script>
